import { gql } from "urql";
export const GetTherapyCategoriesAndSubCategoriesQuery = gql `
    query GetTherapyCategoriesAndSubCategories(
        $search: String
        $offset: Int
    ) {
        therapyCategories {
            therapyCategories(search: $search, offset: $offset) {
                therapyCategoryId
                name
                isActive
                therapySubCategories {
                    therapySubCategoryId
                    therapyCategoryId
                    name
                    isActive
                }
            }
        }
    }
`;
export const GetTherapyCategoryListQuery = gql `
    query GetTherapyCategoryList($inOrganization: Boolean) {
        therapyCategories {
            therapyCategoriesList(inOrganization: $inOrganization) {
                value
                label
            }
        }
    }
`;
export const GetTherapySubCategoryGroupsQuery = gql `
    query GetTherapySubCategoryGroups($therapyCategoryIds: [String]) {
        therapySubCategories {
            therapySubCategoryGroups(therapyCategoryIds: $therapyCategoryIds) {
                group
                items {
                    value
                    label
                }
            }
        }
    }
`;
